import {
    AbstractControl,
    ValidationErrors,
    ValidatorFn,
} from '@angular/forms';

export const range = (min: number, max: number, skipIfValueEmpty = false): ValidatorFn =>
    (c: AbstractControl) =>
        (
            skipIfValueEmpty &&
            (
                c.value == null ||
                c.value === ''
            )
        ) ||
            (
                (min == null || c.value >= min) &&
                (max == null || c.value <= max)
            ) ?
            null :
            {
                range: {
                    valid: false,
                    min,
                    max,
                },
            } as ValidationErrors;

